exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.am-agency-buzz-icon[data-v-4294357e]{\n  float:left;\n  display:block;\n  padding: 0px 3px 0px 0px\n}\n", ""]);

// exports
